import $ from "jquery";
import { accordion } from "./modules/accordion";
import { caseModal } from "./modules/caseModal";
import { caseSlider } from "./modules/caseSlider";
import { serviceSlider } from "./modules/serviceSlider";
import { priceSpTable } from "./modules/priceSpTable";

$(function () {
  accordion();
  caseModal();
  caseSlider();
  serviceSlider();
  priceSpTable();

  window.addEventListener("scroll", function () {
    if (window.scrollY > 200) {
      document.querySelector("body").classList.add("is-scroll");
    } else {
      document.querySelector("body").classList.remove("is-scroll");
    }
  });
});
